import repository from './repsitory'

const resource = '/invoiceParameter'

export default {
    getSingle () {
        return repository.get(`${resource}`)
    },
    update (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
